// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const Link = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.114 17.222l-1.87 1.895a1.423 1.423 0 01-2.032 0l-1.354-1.372a1.469 1.469 0 010-2.058l4.74-4.805a1.423 1.423 0 012.032 0l1.354 1.372L14 11.225l-1.354-1.372a2.847 2.847 0 00-4.064 0l-4.74 4.804a2.94 2.94 0 000 4.118l1.354 1.372a2.847 2.847 0 004.063 0l2.475-2.507a4.26 4.26 0 01-1.62-.418z" />
      <path d="M13.886 7.778l1.87-1.895a1.423 1.423 0 012.032 0l1.355 1.372a1.47 1.47 0 010 2.059l-4.741 4.804c-.561.569-1.47.569-2.032 0l-1.354-1.372L10 13.776l1.354 1.371a2.847 2.847 0 004.064 0l4.74-4.804a2.939 2.939 0 000-4.118l-1.354-1.372a2.846 2.846 0 00-4.063 0L12.267 7.36c.556.03 1.106.17 1.62.418z" />
    </g>
  </svg>
);

export default Link;
